import { useContext } from 'react';
import {
    UniverseConfigurationsContext,
    UniverseConfigurationsContextValue,
} from 'src/features/common/universe/providers/universe-configurations.context';

export const useUniverseConfigurationsContext = (): UniverseConfigurationsContextValue => {
    const value = useContext(UniverseConfigurationsContext);

    return value;
};
